import apiWrapper from "@apiWrapper";
import { ApiResponse } from "@apiTypes";
import { CustomEmail } from "@types";

const getCustomEmailsList = async (): Promise<ApiResponse<CustomEmail>> => {
  return apiWrapper("/custom_emails", "GET");
};

const getCustomEmail = async (id: number): Promise<ApiResponse<CustomEmail>> =>
  apiWrapper(`/custom_emails/${id}`, "GET");

export const createCustomEmail = async (params: {
  body: string;
  brand_id: number;
  bulletin_id: number;
  kind: string;
}): Promise<ApiResponse<CustomEmail>> =>
  apiWrapper(`/custom_emails`, "POST", { custom_email: params });

const updateCustomEmail = async (
  id: number,
  params: { body: string }
): Promise<ApiResponse<CustomEmail>> =>
  apiWrapper(`/custom_emails/${id}`, "PUT", { custom_email: params });

export { getCustomEmailsList, getCustomEmail, updateCustomEmail };
